module.exports = __webpack_public_path__ + "img/edmbet-support.52c58547.png";